// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 3056 ? "app-9342e358" : chunkId) + "." + {"3056":"c9c750b064ecbd384959","5409":"71c059dd3de8dce6ac12"}[chunkId] + ".css";
};